// service.js
import {request as fetch} from './request.js';
import Cookie from 'js-cookie';

const fundebugApikey = 'c222da7dcb8c51421541e8a9ea7cc64c68f7430f8fa2f26501051c73fa0b0350';
const scratchFileStorageHost = 'sb2.hetao101.com';
const scratchJsonFileStorageHost = 'sbdata.hetao101.com';
const scratchFileStorageUpYunHost = 'up-sb3.hetao101.com';

const getApiHost = () => {
    if (window.location.hostname.includes('testing')) {
        const env = location.hostname.match(/\.(\w*)/)[1];
        return `api.${env}.hetao101.com`;
    }
    return 'api.hetao101.com';
};
const getEnv = () => {
    if (window.location.hostname.includes('testing')) {
        return 'dev';
    }
    return 'prod';
};
const loginRedirect = `https://${getApiHost()}/logic/v1/wechat/pc/login?redirect=${window.location}`;

const getViewWorkMobileHost = () => {
    if (window.location.hostname.includes('testing')) {
        return 'mp.testing.hetao101.com';
    }
    return 'm.hetao101.com';
};

const getUploadToken = (bucket = 'history') => {
    if (bucket === 'sbdata' && sessionStorage.getItem('uptoken')) {
        return;
    }
    const ajax = new XMLHttpRequest();
    ajax.open('GET', `https://api.hetao101.com/einstein-logic/v1/qiniu/uptoken?bucket=${bucket}`, false);
    ajax.setRequestHeader('If-Modified-Since', '0');
    ajax.setRequestHeader('Authorization', Cookie.get('token'));
    ajax.send();
    if (ajax.status === 200) {
        const res = JSON.parse(ajax.responseText);
        const uptoken = res.data.uptoken;
        bucket === 'sbdata' && sessionStorage.setItem('uptoken', uptoken);
        return uptoken;
    } 
    // else if (ajax.status === 401) {
    //     window.location.href = loginRedirect;
    // }

    return '';
};

const addHomework = (userId, userName, sectionId, courseId, unitId, lessonId, url, status) => {
    const data = JSON.stringify({
        name: userName,
        userId: userId,
        url: url,
        courseId: courseId,
        unitId: unitId,
        lessonId: lessonId,
        type: 'SCRATCH3',
        sectionId: sectionId,
        status: status
    });

    return fetch(`//${getApiHost()}/logic/v1/homeworks`, {
        method: 'POST',
        body: data
    });
};

// 存储项目文件等url
const projectData = {
    originProjectUrl: null,
    latestWorkUrl: null,
    homeworkUrl: null,
    projectAnswerUrl: null
};

// 请求课程项目文件
const getOriginProjectData = function (courseId, lessonId, unitId){
    if (projectData.originProjectUrl !== null) {
        return new Promise(resolve => {
            resolve(projectData);
        });
    }
    if (unitId === '' || courseId === '' || lessonId === '') {
        return new Promise(resolve => {
            resolve(projectData);
        });
    }
    const data = {
        courses: courseId,
        units: unitId,
        lessons: lessonId
        
    };
    const getQueryString = function (params) {
        const esc = encodeURIComponent;
        return Object.keys(params)
            .map(k => `${esc(k)}/${esc(params[k])}/`)
            .join('');
    };
    const url = `//${getApiHost()}/logic/v1/${getQueryString(data)}`;
    return fetch(url, {
        method: 'get'
    }).then(response => response.json())
        .then(json => {
            if (json.errcode === 0) {
                projectData.originProjectUrl = json.data.project ? json.data.project : null;
            }
            return projectData;
        });
    
  
};

// 请求最近的作品文件可能是草稿也可能是作业
const getLatestWorkData = (userId, courseId, lessonId) => {
    if (projectData.latestWorkUrl !== null) {
        return new Promise(resolve => {
            resolve(projectData);
        });
    }
    if (userId === '' || courseId === '' || lessonId === '') {
        return new Promise(resolve => {
            resolve(projectData);
        });
    }
    const filter = {
        userId: String(userId),
        lessonId: lessonId,
        courseId: courseId
        
    };
    const data = {
        current: 1, // 第一页
        filter: JSON.stringify(filter),
        pageSize: 1, // 每页一条记录
        order: 'commitTime',
        mode: 'simple'
    };
    const getQueryString = function (params) {
        const esc = encodeURIComponent;
        return Object.keys(params)
            .map(k => {
                if (k === 'filter') {
                    return `${esc(k)}=${params[k]}`;
                }
                return `${esc(k)}=${esc(params[k])}`;
            })
            .join('&');
    };
  
    const url = `
    //${getApiHost()}/logic/v1/homeworksByFilter?${getQueryString(data)}`;
    return fetch(url, {
        method: 'get'
    }).then(response => response.json())
        .then(json => {
            if (json.errcode === 0 && json.data.length > 0) {
                projectData.latestWorkUrl = json.data[0].url;
                projectData.projectAnswerUrl = json.data[0].lesson.answer;
            }
            return projectData;
        });
    

};


// 通过homeworkId请求作业文件
const getParticularHomeworkData = homeworkId => {
    if (projectData.homeworkUrl !== null) {
        return new Promise(resolve => {
            resolve(projectData);
        });
    }
    if (homeworkId === '') {
        return new Promise(resolve => {
            resolve(projectData);
        });
    }

    const url = `
    //${getApiHost()}/logic/v1/homeworks/${homeworkId}`;
    return fetch(url, {
        method: 'get'
    }).then(response => response.json())

    // return new Promise((resolve, reject) => {
    //     const req = new XMLHttpRequest();
    //     req.open('GET', url);
    //     req.send();
    //     req.onreadystatechange = function (){
    //         if (req.readyState === 4) {
    //             if (req.status === 200) {
    //                 resolve(req.responseText);
    //             } else {
    //                 reject();
    //             }
    //         }
    //     };
    // }).then(jsonText => JSON.parse(jsonText))


        .then(json => {
            if (json.errcode === 0 && json.data.length > 0) {
                projectData.homeworkUrl = json.data.url;
            }
            return json;
        });
};

const fetchCousreInfo = courseId => {

    const courseInfo = {
        level: null,
        grade: null
    };
    if (courseId === '') {
        return new Promise(resolve => {
            resolve(courseInfo);
        });
    }

    const url = `
    //${getApiHost()}/logic/v1/courses/${courseId}`;
    return fetch(url, {
        method: 'get'
    }).then(response => response.json())

        .then(json => {
            if (json.errcode === 0) {
                courseInfo.level = json.data.level;
                courseInfo.grade = json.data.grade;
            }
            return courseInfo;
        });
};

const fetchCourses = userId => {

    let userCourses = {};
    if (userId === '' || userId === 0) {
        return new Promise(resolve => {
            resolve(userCourses);
        });
    }

    const url = `
    //${getApiHost()}/logic/v1/courses?userId=${userId}`;
    return fetch(url, {
        method: 'get'
    }).then(response => response.json())
        .then(json => {
            if (json.errcode === 0) {
                userCourses = json.data;
            }
            return userCourses;
        });
    

};

const fetchClassInfo = classId => {
    let classInfo = {};
    if (classId === '' || classId === undefined) {
        return new Promise(resolve => {
            resolve(classInfo);
        });
    }
    const url = `//${getApiHost()}/logic/v1/classes/${classId}`;
    return fetch(url, {
        method: 'get'
    }).then(response => response.json())

        .then(json => {
            if (json.errcode === 0) {
                classInfo = json.data;
            }
            return classInfo;
        });
};

const fetchClassIdByCourse = (userId, courseId) => {
    let classInfo = {};
    if (courseId === '') {
        return new Promise(resolve => {
            resolve(classInfo);
        });
    }
    const url = `//${getApiHost()}/logic/v1/classes?userId=${userId}&courseId=${courseId}`;
    return fetch(url, {
        method: 'get'
    }).then(response => response.json())

        .then(json => {
            if (json.errcode === 0) {
                classInfo = json.data[0];
            }
            return classInfo;
        });
};

const fetchUserInfo = userId => {
    let userInfo = {};
    if (userId === '' || userId === 0) {
        return new Promise(resolve => {
            resolve(userInfo);
        });
    }
    const url = `//${getApiHost()}/logic/v1/users/${userId}`;
    return fetch(url, {
        method: 'get'
    }).then(response => response.json())
        .then(json => {
            if (json.errcode === 0) {
                userInfo = json.data;
            }
            return userInfo;
        });
};

const getConfig = () => {
    return Promise.resolve(
        {
            uploadType:'qiniu',
            customerService:'zc'
        }
    )
    // const url = `//config.hetao101.com/s3ide/${getEnv()}/0.0.1.json`;
    // return fetch(url, {
    //     method: 'GET',
    //     headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}
    // }).then(response => response.json())
    //     .then(json => {
    //         const config = json.data;
    //         return config;
    //     });
};

export {
    fundebugApikey,
    loginRedirect,
    scratchFileStorageHost,
    scratchJsonFileStorageHost,
    scratchFileStorageUpYunHost,
    addHomework,
    fetchCousreInfo,
    fetchCourses,
    fetchClassIdByCourse,
    fetchClassInfo,
    fetchUserInfo,
    getApiHost,
    getOriginProjectData,
    getLatestWorkData,
    getParticularHomeworkData,
    getUploadToken,
    getConfig,
    getViewWorkMobileHost
};
